export const shellUiEn = {
  skip: "Skip to content",
  search: "Search pages",
  searchHint: "Search players, clubs, pages…",
  collapse: "Collapse sidebar",
  expand: "Expand sidebar",
  notifications: "Notifications",
  unread: "{{count}} unread",
  markRead: "Mark all as read",
  caughtUp: "You're all caught up",
  loadError: "Couldn't load notifications",
  retry: "Retry",
  all: "All",
  unreadTab: "Unread",
  readTab: "Read",
  clearRead: "Clear read",
  training: "Training",
  announcements: "Announcements",
  offline: "You're offline. Changes will sync when you reconnect.",
  help: "Help",
  settings: "Settings",
  more: "More",
  page: "Page",
  back: "Back",
  roles: "Roles",
  clubs: "Clubs",
  requestRole: "Request another role",
  nowUsing: "Now using FanJago as {{role}}",
  nowClub: "Now using {{club}}",
  undo: "Undo",
  crashTitle: "Something went wrong",
  crashBody: "This screen hit an unexpected error. Try again, or reload FanJago.",
  tryAgain: "Try again",
  reload: "Reload",
  noMatches: "No matches for \"{{query}}\"",
  recent: "Recent",
  goTo: "Go to",
  switchRole: "Switch role",
  trainingToday: "{{count}} sessions today",
  short: {
    home: "Home",
    explore: "Explore",
    events: "Events",
    social: "Social",
    schedule: "Schedule",
    plans: "Plans",
    me: "Me",
    children: "Children",
    fees: "Fees",
    players: "Players",
    welfare: "Welfare",
    payments: "Payments",
    applications: "Applications",
    staff: "Staff",
    programmes: "Programmes",
    posts: "Posts",
    logistics: "Matches",
    reports: "Reports",
    bookings: "Bookings",
    pricing: "Pricing",
    tournaments: "Tournaments",
    approvals: "Approvals",
    users: "Users",
    moderation: "Moderation",
    subscriptions: "Subscriptions",
    more: "More",
  },
};

export const shellUiMs = {
  skip: "Langkau ke kandungan",
  search: "Cari halaman",
  searchHint: "Cari pemain, kelab, halaman…",
  collapse: "Lipat bar sisi",
  expand: "Kembangkan bar sisi",
  notifications: "Pemberitahuan",
  unread: "{{count}} belum dibaca",
  markRead: "Tanda semua dibaca",
  caughtUp: "Semuanya sudah dibaca",
  loadError: "Pemberitahuan tidak dapat dimuatkan",
  retry: "Cuba lagi",
  all: "Semua",
  unreadTab: "Belum dibaca",
  readTab: "Dibaca",
  clearRead: "Padam yang dibaca",
  training: "Latihan",
  announcements: "Pengumuman",
  offline: "Anda di luar talian. Perubahan akan disegerakkan apabila anda bersambung semula.",
  help: "Bantuan",
  settings: "Tetapan",
  more: "Lagi",
  page: "Halaman",
  back: "Kembali",
  roles: "Peranan",
  clubs: "Kelab",
  requestRole: "Mohon peranan lain",
  nowUsing: "Kini menggunakan FanJago sebagai {{role}}",
  nowClub: "Kini menggunakan {{club}}",
  undo: "Buat asal",
  crashTitle: "Sesuatu tidak kena",
  crashBody: "Skrin ini mengalami ralat yang tidak dijangka. Cuba lagi, atau muat semula FanJago.",
  tryAgain: "Cuba lagi",
  reload: "Muat semula",
  noMatches: "Tiada padanan untuk \"{{query}}\"",
  recent: "Terkini",
  goTo: "Pergi ke",
  switchRole: "Tukar peranan",
  trainingToday: "{{count}} sesi hari ini",
  short: {
    home: "Utama",
    explore: "Teroka",
    events: "Acara",
    social: "Sosial",
    schedule: "Jadual",
    plans: "Pelan",
    me: "Saya",
    children: "Anak",
    fees: "Yuran",
    players: "Pemain",
    welfare: "Kebajikan",
    payments: "Bayaran",
    applications: "Permohonan",
    staff: "Kakitangan",
    programmes: "Program",
    posts: "Siaran",
    logistics: "Perlawanan",
    reports: "Laporan",
    bookings: "Tempahan",
    pricing: "Harga",
    tournaments: "Kejohanan",
    approvals: "Kelulusan",
    users: "Pengguna",
    moderation: "Moderasi",
    subscriptions: "Langganan",
    more: "Lagi",
  },
};
